import { render, staticRenderFns } from "./TouchReservationEntrance.vue?vue&type=template&id=347dba68&scoped=true&"
import script from "./TouchReservationEntrance.vue?vue&type=script&lang=js&"
export * from "./TouchReservationEntrance.vue?vue&type=script&lang=js&"
import style0 from "./TouchReservationEntrance.vue?vue&type=style&index=0&id=347dba68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347dba68",
  null
  
)

export default component.exports